/** Дефолты настроек + слияние с сохранённым (порт loadStockDaySettings /
 * productionChangeColor: сервер хранит сырое значение, клиент мержит с дефолтами). */
import { NO_SALES_COLOR, STOCK_DAY_RANGES, type StockDayRange } from "./metrics";

export interface StockDaySettings {
  ranges: StockDayRange[];
  noSalesColor: string;
}

const COLOR_RE = /^#[0-9a-f]{6}$/i;

/** Порт loadStockDaySettings (стр. 4897-4909): санитайз + фолбэк на дефолты. */
export function mergeStockDaySettings(saved: unknown): StockDaySettings {
  const raw = saved as { ranges?: unknown; noSalesColor?: string; no_sales_color?: string } | null;
  const ranges = Array.isArray(raw?.ranges)
    ? (raw.ranges as StockDayRange[])
        .map((r) => ({
          from: Math.max(0, Math.round(Number(r.from) || 0)),
          to: Math.max(0, Math.round(Number(r.to) || 0)),
          color: COLOR_RE.test(r.color ?? "") ? r.color : "#5ec8f2",
          label: String(r.label ?? "").trim(),
        }))
        .filter((r) => r.to >= r.from)
    : [];
  const noSales = raw?.noSalesColor ?? raw?.no_sales_color ?? "";
  return {
    ranges: ranges.length ? ranges : STOCK_DAY_RANGES.map((r) => ({ ...r })),
    noSalesColor: COLOR_RE.test(noSales) ? noSales : NO_SALES_COLOR,
  };
}

/** Палитра подсветки правок производства (порт стр. 6122-6140): 53 цвета по неделе правки. */
export const CHANGE_PALETTE = [
  "#5ec8f2", "#ffd766", "#58d69b", "#7a6cf0", "#ff8f6b", "#7aa7ff", "#f06b6b", "#9fe870",
];

export function defaultChangeColors(): string[] {
  return Array.from({ length: 53 }, (_, i) => CHANGE_PALETTE[i % CHANGE_PALETTE.length]!);
}

/** saved[i] || default[i] — поэлементное слияние, как в оригинале. */
export function mergeChangeColors(saved: unknown): string[] {
  const defaults = defaultChangeColors();
  if (!Array.isArray(saved)) return defaults;
  return defaults.map((d, i) => {
    const v = saved[i];
    return typeof v === "string" && COLOR_RE.test(v) ? v : d;
  });
}

/** Цвет правки по неделе редактирования (порт productionChangeColor). */
export function changeColorFor(editWeek: number, colors: string[]): string {
  const idx = Math.min(Math.max(editWeek - 1, 0), 52);
  return colors[idx] ?? "#5ec8f2";
}
